import React from 'react';
import PropTypes from 'prop-types';

import LocationAnalysisItem from '../../objects/LocationAnalysisItem';
import UserPreferences from '../../objects/UserPreferences';
import LocationAnalysisItemOrigin from '../../enums/LocationAnalysisItemOrigin';
import * as SelfStoragePointType from '../../enums/SelfStoragePointType';

class InfoBubbleMoreDetails extends React.Component {
    onClick = () => {
        const {
            featureId,
            featureProperties,
            titleColumnId,
            point,
            surveyCode,
            onOpenMoreInfo,
            userPreferences,
        } = this.props;

        const pointType = SelfStoragePointType.resolvePointTypeFromSurveyCode(surveyCode);

        if (!pointType) {
            return;
        }

        const title = featureProperties[titleColumnId];

        const { analysisTypeId, selection } =
            UserPreferences.toLocationAnalysisFormat(userPreferences);

        const newLocationAnalysisItem = new LocationAnalysisItem({
            id: featureId,
            type: pointType,
            value: title,
            point,
            itemOrigin: LocationAnalysisItemOrigin.LIBRARY_LAYER_FEATURE,
            analysisTypeId,
            selection,
        });

        const visualReportProps = {
            report: 'selfstorage-point-info',
            pointType,
            facilityId: featureId,
        };

        onOpenMoreInfo(newLocationAnalysisItem, visualReportProps);
    };

    render() {
        const { surveyCode } = this.props;

        const pointType = SelfStoragePointType.resolvePointTypeFromSurveyCode(surveyCode);

        if (!pointType) {
            return null;
        }

        return (
            <div className="footer">
                <button className="btn btn-link" onClick={this.onClick}>
                    More details
                </button>
            </div>
        );
    }
}

InfoBubbleMoreDetails.propTypes = {
    featureId: PropTypes.string.isRequired,
    featureProperties: PropTypes.object.isRequired,
    titleColumnId: PropTypes.string.isRequired,
    surveyCode: PropTypes.string,
    point: PropTypes.object.isRequired,
    onOpenMoreInfo: PropTypes.func.isRequired,
    userPreferences: PropTypes.object,
};

InfoBubbleMoreDetails.defaultProps = {
    surveyCode: null,
    userPreferences: undefined,
};

export default InfoBubbleMoreDetails;
